<template>
 <v-img
    class="d-inline-block ml-4"
    :src="resHubLogoUrl"
    :height="numHeight"
    :width="computedWidth"
    :style="{ flex: '0 0 auto', maxWidth: 'none' }"
    contain
  />
</template>

<script>
export default {
   props: {
    smallSize: { type: Boolean, default: false },
    height: { type: [Number, String], default: null },
    width:  { type: [Number, String], default: null },
    aspectRatio: { type: Number, default: 2 }
  },
  computed: {
    numHeight() {
      return this.height != null ? Number(this.height) : null;
    },
    computedWidth() {
      if (this.width != null) return Number(this.width);
      return this.numHeight != null ? this.numHeight * this.aspectRatio : null;
    }
  },
  data() {
    return {
      resHubLogoUrl: require("../../assets/reshub/reshub-logo-300x332.png")
    };
  }
};
</script>
